import React from 'react'

import './Home.css'

import FeaturedCategory from './FeaturedCategory/FeaturedCategory';
import Slider from './Slider/Slider';
import Counter from './Counter/Counter';
import WhyKhoj from './WhyKhoj/WhyKhoj';
import Partner from './Partner/Partner';

function Home() {

   return (
      <>
         <FeaturedCategory />
         <Slider />
         <Counter />
         <WhyKhoj />
         <Partner />
      </>
   )
}

export default Home